<!-- <p-toast></p-toast> -->

<div class="dashboardTable">
    <p-table #ddReport [value]="drillDownData" dataKey="AppID" [rows]="10" [paginator]="true"
        [globalFilterFields]="[
        'AppID',
        'Program_Name',
        'District',
        'Block',
        'Village'
        ]" responsiveLayout="scroll" [rowHover]="true"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{ 'Drill Down Report' }}</h5>
                <span>
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'DOWNLOAD' | translate}}"
                        icon="pi pi-download" class="p-button-help"></button>

                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </span>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="ddReport.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <!-- <th pFrozenColumn pSortableColumn="Srno">{{'SR_NO'| translate}}
                        <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                        <p-sortIcon field="Srno"></p-sortIcon>
                    </th> -->
                <th pSortableColumn="AppID">{{'APP_ID'| translate}}</th>
                <th pSortableColumn="Program_Name">{{'PROGRAMME_NAME'| translate}}</th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}</th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}</th>
                <th pSortableColumn="Village">{{'VILLAGE'| translate}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <!-- <td pFrozenColumn>{{tankAbstract.Srno}}</td> -->
                <td>{{data.AppID}}</td>
                <td>{{data.Program_Name}}</td>
                <td>{{data.District}}</td>
                <td>{{data.Block}}</td>
                <td>{{data.Village}}</td>
            </tr>
        </ng-template>


    </p-table>
</div>